// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsOneFingerStageNavigation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.0001 26V17.3248C11.4921 16.9954 9.56602 16.3796 7.98111 15.4173C6.11324 14.2832 4.36543 12.4155 5.02994 9.75746C5.57022 7.59634 6.64126 5.73309 7.55585 4.42654C8.01603 3.76915 8.4439 3.24236 8.75889 2.87763C8.84896 2.77333 8.92998 2.68209 9.00008 2.60463V0H11L11.0001 3.41421L10.708 3.70627L10.7072 3.70711L10.7042 3.71019L10.6846 3.73022C10.6663 3.74914 10.6376 3.7791 10.5998 3.8196C10.524 3.90064 10.4117 4.0237 10.2725 4.18487C9.99377 4.50764 9.60914 4.98085 9.19432 5.57346C8.3589 6.76691 7.42994 8.40366 6.97023 10.2425C6.63474 11.5845 7.38693 12.7168 9.01906 13.7077C10.6224 14.6812 12.7371 15.2757 14.1645 15.5136L15.0001 15.6529V26C15.0001 26.5523 15.4478 27 16.0001 27C16.5524 27 17.0001 26.5523 17.0001 26V13.5C17.0001 11.8983 19.0391 11.2186 20.0001 12.5L22.6513 16.0349C22.737 16.1493 22.8922 16.1859 23.02 16.122C23.1532 16.0554 23.2188 15.8966 23.1665 15.7512L23.0521 15.4324C21.3488 10.6875 20.3118 7.79854 17.3493 5.25926L17.0001 4.95993L17 0H19.0001V4.04871C22.1071 6.86855 23.2826 10.1479 24.8597 14.5478L25.0488 15.0751C25.4415 16.1684 24.9586 17.3888 23.9145 17.9108C22.9221 18.407 21.717 18.1225 21.0513 17.2349L19.0001 14.5V26C19.0001 27.6569 17.657 29 16.0001 29C14.3433 29 13.0001 27.6569 13.0001 26Z" class="svg-bg"/>
  <path d="M7.5599 24 .226562 32H31.773L24.4397 24H20.9998V26H23.5599L27.2266 30H4.77303L8.4397 26H10.9998V24H7.5599ZM9 20H4V18L0 21 4 24V22H9V20ZM23 22H28V24L32 21 28 18V20H23V22Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsOneFingerStageNavigation is a generated icon component.
 */
let IconRmsOneFingerStageNavigation = IconRmsOneFingerStageNavigation_1 = class IconRmsOneFingerStageNavigation extends IconBaseElement {
    render() {
        return html `${IconRmsOneFingerStageNavigation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsOneFingerStageNavigation.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsOneFingerStageNavigation = IconRmsOneFingerStageNavigation_1 = __decorate([
    customElement('zui-icon-rms-one-finger-stage-navigation')
], IconRmsOneFingerStageNavigation);
export { IconRmsOneFingerStageNavigation };
